import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EdgeNetworkComponent } from './edge-network.component';
import { EdgeNetworkDetailsComponent } from './edge-network-details/edge-network-details.component';
const routes: Routes = [
  {
    path: '',
    component: EdgeNetworkComponent,
    title: 'Tenant Edge Network'
  },
  {
    path: ':envt',
    component: EdgeNetworkDetailsComponent,
    title: 'Tenant Edge Network'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EdgeNetworkRoutingModule { }
